module.exports = __webpack_public_path__ + "img/pay_01.804dc354.png";